import KatalLogger, { Level } from '@amzn/katal-logger';

const katalLoggerConfig = {
  url: 'dev-yyalex.chub-log.controllershiphub.finergy.amazon.dev',
  logThreshold: Level.INFO,
  maxLogLineSize: 10000,
  logToConsole: false,
};

export const logger = new KatalLogger(katalLoggerConfig);
logger.addErrorListener();
